import Brands from '@page-components/Order/Products/ProductsContent/Brands'
import React from 'react'

export default function MultiBrandBar({setFilter, scrollToCategory}) {
  return <Brands scrollTo={category => scrollToCategory(category)} onClick={() => setFilter('')} />
}
